import ProfileContent from "../../../components/User/Profile"

const Profile = () => {

    return (
        <>
            <h1 className="font-doran text-center mb-4 font-medium">  اطلاعات پروفایل کاربری </h1>

            <ProfileContent />

        </>
    )

}

export default Profile